<template>
  <q-page>
    <div>  
      <DefineWork></DefineWork>
    </div>
  </q-page>
</template>

<script>
import { date } from 'quasar'
import DefineWork from '@/components/DefineWork/DefineWork.vue'
export default {
  name: 'Distribute',
  components: {
    DefineWork,
  },
  data: function () {
    return {
      
    }
  }
}
</script>
<style scoped>
.content{
  padding: 10px;
}
</style>
